<template>
  <div>
    <app-header />
    <router-view/>
    <app-footer />
    <login />
  </div>
</template>

<style lang="less">
  @import '../../less/common';
  @import '../../less/front';
</style>

<script>
import AppHeader from './common/AppHeader.vue';
import AppFooter from './common/AppFooter.vue';
import Login from './common/Login.vue';

export default {
  components: { Login, AppHeader, AppFooter },
  mounted() {
    if (this.$route.query.afterLogin) {
      this.$store.commit('openLogin', this.$route.query.afterLogin);
      this.$router.replace({ query: {} });
    }
    document.title = this.asset('name');
  },
};
</script>



// WEBPACK FOOTER //
// src/views/front/template.vue